import React from "react";
import SocialMediaList from "./SocialMediaList";
import Label from "../atoms/Label";
import ExpandableText from "../molecules/ExpandableText";
import Image from "../atoms/Image";

export default ({ image, label, name, description, socialMedia }) =>
    <div className="o-author u-container u-container--medium">
        <div className="o-author__row o-author__row--flex">
            <Image className="o-author__img" image={ image }/>
            <div className="o-author__info">
                <Label text={ label }/>
                <p className="o-author__name">{ name }</p>
            </div>
        </div>
        <div className="o-author__row">
            <ExpandableText text={ description }/>
        </div>
        <div className="o-author__row">
            <SocialMediaList socialMedia={ socialMedia } isRound/>
        </div>
    </div>;
